module.exports = __webpack_public_path__ + "img/2.0f60fa2b.png";